// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2LVmj","left":"styles_left__3vR9z"};